import {
    USER_SUBMIT_FRUI_QPBZ_BEGIN,
    USER_SUBMIT_FRUI_QPBZ_SUCCESS,
    USER_SUBMIT_FRUI_QPBZ_FAILURE,
    USER_SUBMIT_FRUI_QPBZ_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_qpbz(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_QPBZ_BEGIN,
      });
  
      let apiurl = '/api/b/frui_qpbz/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/frui_qpbz/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_QPBZ_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_QPBZ_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_qpbzError() {
    return {
      type: USER_SUBMIT_FRUI_QPBZ_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_QPBZ_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_qpbzPending: true,
          submitFrui_qpbzError: null,
        };
  
      case USER_SUBMIT_FRUI_QPBZ_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_qpbzPending: false,
          submitFrui_qpbzError: null,
        };
  
      case USER_SUBMIT_FRUI_QPBZ_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_qpbzPending: false,
          submitFrui_qpbzError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_QPBZ_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_qpbzError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_qpbz.js